import {
  HISTORY_GET_SPORT_BETS_HISTORY,
  USER_CHECK,
  USER_SIGN_IN,
  USER_SIGN_OUT,
  USER_UPDATE_BALANCE,
  USER_UPDATE_DATA,
  USER_UPDATE_PASSWORD,
} from "../constants";

export const updateBalance = () => {
  return (dispatch) => {
    dispatch({
      type: USER_UPDATE_BALANCE,
      payload: {},
    });
  };
};

export const updateData = ({ name, email, phone }) => {
  return (dispatch) => {
    dispatch({
      type: USER_UPDATE_DATA,
      payload: { name, email, phone },
    });
  };
};

export const changePassword = ({ oldPassword, newPassword }) => {
  return (dispatch) => {
    dispatch({
      type: USER_UPDATE_PASSWORD,
      payload: { oldPassword, newPassword },
    });
  };
};

export const checkUser = () => {
  return (dispatch) => {
    dispatch({
      type: USER_CHECK,
      payload: {},
    });
  };
};

export const signIn = (username, password) => {
  return (dispatch) => {
    dispatch({
      type: USER_SIGN_IN,
      payload: { username, password },
    });
  };
};

export const signOut = () => {
  return (dispatch) => {
    dispatch({
      type: USER_SIGN_OUT,
      payload: {},
    });
  };
};

export const fetchSportBetsHistory = (payload) => {
  return (dispatch) => {
    dispatch({
      type: HISTORY_GET_SPORT_BETS_HISTORY,
      payload,
    });
  };
};
